var map = {
	"./Blog/APITesting": [
		32972,
		50
	],
	"./Blog/APITesting.js": [
		32972,
		50
	],
	"./Blog/AndroidDevelopment": [
		53983,
		4543
	],
	"./Blog/AndroidDevelopment.js": [
		53983,
		4543
	],
	"./Blog/BackEndDevelopment": [
		99021,
		4585
	],
	"./Blog/BackEndDevelopment.js": [
		99021,
		4585
	],
	"./Blog/CertifiedCloudExpert": [
		25703,
		6174
	],
	"./Blog/CertifiedCloudExpert.js": [
		25703,
		6174
	],
	"./Blog/CertifiedDevOpsExpert": [
		5778,
		6047
	],
	"./Blog/CertifiedDevOpsExpert.js": [
		5778,
		6047
	],
	"./Blog/CertifiedKubernetesExpert": [
		90611,
		5847
	],
	"./Blog/CertifiedKubernetesExpert.js": [
		90611,
		5847
	],
	"./Blog/Covid": [
		87451,
		7451
	],
	"./Blog/Covid.js": [
		87451,
		7451
	],
	"./Blog/FrontEndDevelopment": [
		10768,
		3292
	],
	"./Blog/FrontEndDevelopment.js": [
		10768,
		3292
	],
	"./Blog/FullStackDevelopment": [
		95978,
		6221
	],
	"./Blog/FullStackDevelopment.js": [
		95978,
		6221
	],
	"./Blog/HybridDevelopment": [
		52633,
		2194
	],
	"./Blog/HybridDevelopment.js": [
		52633,
		2194
	],
	"./Blog/IOSDevelopment": [
		12919,
		277
	],
	"./Blog/IOSDevelopment.js": [
		12919,
		277
	],
	"./Blog/List": [
		86240,
		6240
	],
	"./Blog/List.js": [
		86240,
		6240
	],
	"./Blog/MobileTesting": [
		87951,
		6075
	],
	"./Blog/MobileTesting.js": [
		87951,
		6075
	],
	"./Blog/PerformanceTesting": [
		43720,
		2508
	],
	"./Blog/PerformanceTesting.js": [
		43720,
		2508
	],
	"./Blog/TestAutomation": [
		20803,
		8994
	],
	"./Blog/TestAutomation.js": [
		20803,
		8994
	],
	"./Blog/TopDeveloperInIndiaFor2022": [
		78608,
		7079
	],
	"./Blog/TopDeveloperInIndiaFor2022.js": [
		78608,
		7079
	],
	"./Blog/UIUXDesign": [
		86500,
		8168
	],
	"./Blog/UIUXDesign.js": [
		86500,
		8168
	],
	"./Blog/WebTesting": [
		70980,
		1028
	],
	"./Blog/WebTesting.js": [
		70980,
		1028
	],
	"./Blog/data": [
		29097
	],
	"./Blog/data.js": [
		29097
	],
	"./CaseStudies/AutomatedWorkforceManagement": [
		13010,
		2382,
		3010
	],
	"./CaseStudies/AutomatedWorkforceManagement.js": [
		13010,
		2382,
		3010
	],
	"./CaseStudies/AutomobilesItStaffManagement": [
		43707,
		2382,
		3707
	],
	"./CaseStudies/AutomobilesItStaffManagement.js": [
		43707,
		2382,
		3707
	],
	"./CaseStudies/CaseStudies": [
		15054
	],
	"./CaseStudies/CaseStudies.js": [
		15054
	],
	"./CaseStudies/CrowdfundingPlatform": [
		25174,
		2382,
		5174
	],
	"./CaseStudies/CrowdfundingPlatform.js": [
		25174,
		2382,
		5174
	],
	"./CaseStudies/CustomerRelationshipManagement": [
		65446,
		2382,
		5446
	],
	"./CaseStudies/CustomerRelationshipManagement.js": [
		65446,
		2382,
		5446
	],
	"./CaseStudies/DeliveryManagementSystem": [
		59045,
		2382,
		9045
	],
	"./CaseStudies/DeliveryManagementSystem.js": [
		59045,
		2382,
		9045
	],
	"./CaseStudies/ELearningInMusic": [
		64670,
		2382,
		4670
	],
	"./CaseStudies/ELearningInMusic.js": [
		64670,
		2382,
		4670
	],
	"./CaseStudies/ELearningTraining": [
		62012,
		2382,
		2012
	],
	"./CaseStudies/ELearningTraining.js": [
		62012,
		2382,
		2012
	],
	"./CaseStudies/EbooksVendor": [
		59034,
		2382,
		9034
	],
	"./CaseStudies/EbooksVendor.js": [
		59034,
		2382,
		9034
	],
	"./CaseStudies/Ecommerce": [
		8259,
		2382,
		8259
	],
	"./CaseStudies/Ecommerce.js": [
		8259,
		2382,
		8259
	],
	"./CaseStudies/List": [
		54143,
		4143
	],
	"./CaseStudies/List.js": [
		54143,
		4143
	],
	"./CaseStudies/MultilevelMarketingMlm": [
		458,
		2382,
		458
	],
	"./CaseStudies/MultilevelMarketingMlm.js": [
		458,
		2382,
		458
	],
	"./CaseStudies/OnlineFoodDeliveryAndEventsBooking": [
		81703,
		2382,
		1703
	],
	"./CaseStudies/OnlineFoodDeliveryAndEventsBooking.js": [
		81703,
		2382,
		1703
	],
	"./CaseStudies/OnlineLogisticsSystem": [
		78732,
		2382,
		8732
	],
	"./CaseStudies/OnlineLogisticsSystem.js": [
		78732,
		2382,
		8732
	],
	"./CaseStudies/OnlineMedicalConsultation": [
		68724,
		2382,
		8724
	],
	"./CaseStudies/OnlineMedicalConsultation.js": [
		68724,
		2382,
		8724
	],
	"./CaseStudies/OnlineParcelDeliverySystem": [
		35868,
		2382,
		5868
	],
	"./CaseStudies/OnlineParcelDeliverySystem.js": [
		35868,
		2382,
		5868
	],
	"./CaseStudies/OnlineTravelPlatform": [
		3967,
		3967
	],
	"./CaseStudies/OnlineTravelPlatform.js": [
		3967,
		3967
	],
	"./CaseStudies/PharmacyOrderManagement": [
		75891,
		2382,
		5891
	],
	"./CaseStudies/PharmacyOrderManagement.js": [
		75891,
		2382,
		5891
	],
	"./CaseStudies/ProjectManagementAndTimeSchedule": [
		72000,
		2382,
		2000
	],
	"./CaseStudies/ProjectManagementAndTimeSchedule.js": [
		72000,
		2382,
		2000
	],
	"./CaseStudies/ProjectManagementApplication": [
		72771,
		2382,
		2771
	],
	"./CaseStudies/ProjectManagementApplication.js": [
		72771,
		2382,
		2771
	],
	"./CaseStudies/SchoolSchedulingSoftware": [
		82296,
		2382,
		2296
	],
	"./CaseStudies/SchoolSchedulingSoftware.js": [
		82296,
		2382,
		2296
	],
	"./CaseStudies/Sidebar": [
		52043,
		2043
	],
	"./CaseStudies/Sidebar.js": [
		52043,
		2043
	],
	"./CaseStudies/StudentPerformanceTracking": [
		56965,
		2382,
		6965
	],
	"./CaseStudies/StudentPerformanceTracking.js": [
		56965,
		2382,
		6965
	],
	"./CaseStudies/TaskManagementSystem": [
		63420,
		2382,
		3420
	],
	"./CaseStudies/TaskManagementSystem.js": [
		63420,
		2382,
		3420
	],
	"./CaseStudies/TimeFunding": [
		56049,
		2382,
		6049
	],
	"./CaseStudies/TimeFunding.js": [
		56049,
		2382,
		6049
	],
	"./CaseStudies/TradeUnionWebsiteRedeveloped": [
		78930,
		2382,
		8930
	],
	"./CaseStudies/TradeUnionWebsiteRedeveloped.js": [
		78930,
		2382,
		8930
	],
	"./CaseStudies/VideoConferencingPlatform": [
		10398,
		2382,
		398
	],
	"./CaseStudies/VideoConferencingPlatform.js": [
		10398,
		2382,
		398
	],
	"./CaseStudies/WeddingEventPlanner": [
		88915,
		2382,
		8915
	],
	"./CaseStudies/WeddingEventPlanner.js": [
		88915,
		2382,
		8915
	],
	"./CaseStudies/data": [
		66367,
		6367
	],
	"./CaseStudies/data.js": [
		66367,
		6367
	],
	"./CompetencyMatrix/ArtificialIntelligence": [
		15654,
		4815
	],
	"./CompetencyMatrix/ArtificialIntelligence.js": [
		15654,
		4815
	],
	"./CompetencyMatrix/BlockChain": [
		45982,
		7644
	],
	"./CompetencyMatrix/BlockChain.js": [
		45982,
		7644
	],
	"./CompetencyMatrix/CloudComputing": [
		95341,
		4500
	],
	"./CompetencyMatrix/CloudComputing.js": [
		95341,
		4500
	],
	"./CompetencyMatrix/DataScience": [
		77591,
		4071
	],
	"./CompetencyMatrix/DataScience.js": [
		77591,
		4071
	],
	"./CompetencyMatrix/Devops": [
		52694,
		1687
	],
	"./CompetencyMatrix/Devops.js": [
		52694,
		1687
	],
	"./CompetencyMatrix/EnterpriseMobility": [
		11769,
		5751,
		9792
	],
	"./CompetencyMatrix/EnterpriseMobility.js": [
		11769,
		5751,
		9792
	],
	"./CompetencyMatrix/EnterpriseWebApplication": [
		56351,
		4870
	],
	"./CompetencyMatrix/EnterpriseWebApplication.js": [
		56351,
		4870
	],
	"./CompetencyMatrix/InternetOfThings": [
		91304,
		6650
	],
	"./CompetencyMatrix/InternetOfThings.js": [
		91304,
		6650
	],
	"./CompetencyMatrix/QualityAssurance": [
		64222,
		5751,
		9405
	],
	"./CompetencyMatrix/QualityAssurance.js": [
		64222,
		5751,
		9405
	],
	"./CompetencyMatrix/Sidebar": [
		60234,
		234
	],
	"./CompetencyMatrix/Sidebar.js": [
		60234,
		234
	],
	"./Home": [
		89723,
		2382,
		1415,
		4270
	],
	"./Home.js": [
		89723,
		2382,
		1415,
		4270
	],
	"./IndustryFocus/Automotive": [
		34697,
		2382,
		688
	],
	"./IndustryFocus/Automotive.js": [
		34697,
		2382,
		688
	],
	"./IndustryFocus/BankFinancialServices": [
		50504,
		2382,
		748
	],
	"./IndustryFocus/BankFinancialServices.js": [
		50504,
		2382,
		748
	],
	"./IndustryFocus/ECommerceRetail": [
		44006,
		2382,
		5751,
		1083
	],
	"./IndustryFocus/ECommerceRetail.js": [
		44006,
		2382,
		5751,
		1083
	],
	"./IndustryFocus/EducationAcademics": [
		18496,
		2382,
		8496
	],
	"./IndustryFocus/EducationAcademics.js": [
		18496,
		2382,
		8496
	],
	"./IndustryFocus/HealthcarePharmaceutical": [
		17043,
		5751,
		1502
	],
	"./IndustryFocus/HealthcarePharmaceutical.js": [
		17043,
		5751,
		1502
	],
	"./IndustryFocus/HiTechManufacturing": [
		57429,
		6228
	],
	"./IndustryFocus/HiTechManufacturing.js": [
		57429,
		6228
	],
	"./IndustryFocus/ITTelecom": [
		21337,
		2382,
		4683
	],
	"./IndustryFocus/ITTelecom.js": [
		21337,
		2382,
		4683
	],
	"./IndustryFocus/MiningJewellery": [
		3540,
		2382,
		9433
	],
	"./IndustryFocus/MiningJewellery.js": [
		3540,
		2382,
		9433
	],
	"./IndustryFocus/Others": [
		98722,
		7829
	],
	"./IndustryFocus/Others.js": [
		98722,
		7829
	],
	"./IndustryFocus/Sidebar": [
		324,
		324
	],
	"./IndustryFocus/Sidebar.js": [
		324,
		324
	],
	"./IndustryTrends/CustomerSelfService": [
		54101,
		4101
	],
	"./IndustryTrends/CustomerSelfService.js": [
		54101,
		4101
	],
	"./IndustryTrends/FacialRecognition": [
		41219,
		1219
	],
	"./IndustryTrends/FacialRecognition.js": [
		41219,
		1219
	],
	"./IndustryTrends/List": [
		23502,
		8077
	],
	"./IndustryTrends/List.js": [
		23502,
		8077
	],
	"./IndustryTrends/data": [
		42060,
		6259
	],
	"./IndustryTrends/data.js": [
		42060,
		6259
	],
	"./ProfessionalServices/ApplicationIntegration": [
		65548,
		5751,
		3561
	],
	"./ProfessionalServices/ApplicationIntegration.js": [
		65548,
		5751,
		3561
	],
	"./ProfessionalServices/CustomAppDevelopment": [
		71187,
		5751,
		6793
	],
	"./ProfessionalServices/CustomAppDevelopment.js": [
		71187,
		5751,
		6793
	],
	"./ProfessionalServices/EmergingTechDevelopment": [
		67647,
		9736
	],
	"./ProfessionalServices/EmergingTechDevelopment.js": [
		67647,
		9736
	],
	"./ProfessionalServices/ITConsulting": [
		71411,
		8305
	],
	"./ProfessionalServices/ITConsulting.js": [
		71411,
		8305
	],
	"./ProfessionalServices/MaintenanceSupport": [
		76222,
		5819
	],
	"./ProfessionalServices/MaintenanceSupport.js": [
		76222,
		5819
	],
	"./ProfessionalServices/MobileAppDevelopment": [
		89875,
		6949
	],
	"./ProfessionalServices/MobileAppDevelopment.js": [
		89875,
		6949
	],
	"./ProfessionalServices/Sidebar": [
		43785,
		3785
	],
	"./ProfessionalServices/Sidebar.js": [
		43785,
		3785
	],
	"./banner/Home1_banner": [
		72896,
		8082
	],
	"./banner/Home1_banner.js": [
		72896,
		8082
	],
	"./pages/Aboutus": [
		1840,
		2382,
		5751,
		5660
	],
	"./pages/Aboutus.js": [
		1840,
		2382,
		5751,
		5660
	],
	"./pages/CancellationAndRefundPolicy": [
		76912,
		2382,
		3556
	],
	"./pages/CancellationAndRefundPolicy.js": [
		76912,
		2382,
		3556
	],
	"./pages/Careers": [
		43781,
		2382,
		1127
	],
	"./pages/Careers.js": [
		43781,
		2382,
		1127
	],
	"./pages/Contact": [
		58154,
		8705,
		8154
	],
	"./pages/Contact.js": [
		58154,
		8705,
		8154
	],
	"./pages/Cookie": [
		96290,
		6290
	],
	"./pages/Cookie.js": [
		96290,
		6290
	],
	"./pages/Error": [
		11460,
		1460
	],
	"./pages/Error.js": [
		11460,
		1460
	],
	"./pages/Faq": [
		23550,
		4705,
		3550
	],
	"./pages/Faq.js": [
		23550,
		4705,
		3550
	],
	"./pages/OurWorkingProcess": [
		55120,
		5120
	],
	"./pages/OurWorkingProcess.js": [
		55120,
		5120
	],
	"./pages/PrivacyPolicy": [
		50696,
		696
	],
	"./pages/PrivacyPolicy.js": [
		50696,
		696
	],
	"./pages/SalesPartnerProgram": [
		57188,
		7188
	],
	"./pages/SalesPartnerProgram.js": [
		57188,
		7188
	],
	"./pages/TermsConditions": [
		57091,
		7091
	],
	"./pages/TermsConditions.js": [
		57091,
		7091
	],
	"./pages/Testimonial/data": [
		20343,
		3873
	],
	"./pages/Testimonial/data.js": [
		20343,
		3873
	],
	"./pages/Testimonial/list": [
		81900,
		4614
	],
	"./pages/Testimonial/list.js": [
		81900,
		4614
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99555;
module.exports = webpackAsyncContext;